import React from 'react';
import {useTranslation} from '../../i18n/translation';
import '../../css/productFaq.css';

// Shared FAQ block for product cards, leasing and knowledge-base articles.
export function ProductFaq({items, theme, introduction, id, heading}) {
    const {t} = useTranslation();
    if (!items?.length) return null;

    const headingId = id ? `${id}-title` : 'product-faq-title';
    const description = introduction ?? t('Ответы на основные вопросы о конструкции, комплектации и проектировании платформы.');

    return (
        <section id={id} className={`product-faq ${theme || ''}`} aria-labelledby={headingId}>
            <div className="product-faq__heading">
                <span className="product-faq__eyebrow">{t('Полезная информация')}</span>
                <h2 id={headingId}>{heading || t('Частые вопросы')}</h2>
                {description ? <p>{description}</p> : null}
            </div>
            <div className="product-faq__list">
                {items.map((item, index) => (
                    <details className="product-faq__item" key={`${item.question}-${index}`}>
                        <summary>
                            <span>{item.question}</span>
                            <span className="product-faq__icon" aria-hidden="true" />
                        </summary>
                        <div className="product-faq__answer">
                            <p>{item.answer}</p>
                        </div>
                    </details>
                ))}
            </div>
        </section>
    );
}
